import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import uiDux from 'src/redux/ui';
import appDux from 'src/redux/app';
import { LogoContainer, LogoHouse, LogoText, LogoHouseText } from './styled';

export const mapStateToProps = (state) => ({
  isSidebarOpen: state.designPro.ui.isSidebarOpen,
  shouldRenderFooterLogoText: uiDux.selectors.shouldRenderFooterLogoText(state),
});

export class FooterLogo extends PureComponent {
  static propTypes = {
    isSidebarOpen: PropTypes.bool.isRequired,
    shouldRenderFooterLogoText: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    isSidebarOpen: false,
  };

  render() {
    const { isSidebarOpen, shouldRenderFooterLogoText } = this.props;

    return (
      <LogoContainer isDisplayed={!isSidebarOpen} data-selenium="footerLogo">
        <LogoHouseText />
      </LogoContainer>
    );
  }
}

export default connect(mapStateToProps)(FooterLogo);
